import { DashboardService } from 'src/app/dashboard/dashboard.service';

import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ValidatorFn,
  AbstractControl,
  FormControl,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { OrgMap, ADMIN_CONSTANT, GLOBAL_CONSTANTS } from 'src/app/app.model';
import { AppService } from 'src/app/app.service';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { interval, timer, Subject } from 'rxjs';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {

  maxDOB: Date;
  title: string;
  email: string;
  orgList: OrgMap;
  isInitial: boolean;
  resetPassword: boolean;
  forgotPassword: boolean;
  passwordForm: FormGroup;
  selectedOrganization: OrgMap;

  destroy: Subject<any> = new Subject<any>();

  forgotPasswordForm: FormGroup;
  resendOTP = false;
  resendOTPTimer: number = 0;
  formSubmitted: boolean = false;
  showOTPBox = false;
  registerUserEmail:string;

  @ViewChild('OTP', { static: false }) OTP: any;

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private changeDetector: ChangeDetectorRef,
    private service: AppService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public dashService: DashboardService
  ) { 


    this.dashService.userInfo.pipe(takeUntil(this.destroy)).subscribe((val) => {
      if (!!val) {
        // console.log(val)
        this.registerUserEmail = val.Email
      }
    })


  }

  ngOnInit(): void {
    this.onInit();
    this.initForm();
  }

  ngOnDestroy() {
    this.destroy.next(null);
    this.destroy.complete();
  }

  onInit(): void {
    this.email = this.data.email;
    this.orgList = this.data.orgMap;
    this.resetPassword = this.data.resetPassword;
    this.forgotPassword = this.data.forgotPassword;

    this.title =
      this.resetPassword || this.forgotPassword
        ? `Change Password`
        : `Select Organization`;

    let items: OrgMap[] = [];
    if (!!this.service.getToken(ADMIN_CONSTANT.ADMIN_TOKEN_ORG_CODE)) {
      items = this.data.orgMap.filter(
        (x: OrgMap) =>
          x.OrgCode ===
          this.service.getToken(ADMIN_CONSTANT.ADMIN_TOKEN_ORG_CODE)
      );
    } else {
      items = this.data.orgMap;
    }

    this.selectedOrganization = !!items && !!items.length ? items[0] : null;
  }

  initForm(): void {
    if (this.resetPassword || this.forgotPassword) {
      this.isInitial = true;
      this.maxDOB = moment().toDate();
      this.passwordForm = this.fb.group(
        {
          InputOTP: this.fb.control(null),
          Email: this.fb.control(this.registerUserEmail),
          AdminPassword: this.fb.control(null, [Validators.required, Validators.minLength(8)]),
          NewAdminPassword: this.fb.control(null, [Validators.required, Validators.minLength(8)]),

          ReNewAdminPassword: this.fb.control(null, [Validators.required, Validators.minLength(8)]),
          
          DOB: this.fb.control({ value: this.maxDOB}, [
            Validators.required,
          ]),
        },
        { validator: this.passwordValidator('NewAdminPassword', 'ReNewAdminPassword') }
      );
      // if (!!this.passwordForm.get('Email').value) {
      //   this.passwordForm.get('Email').disable({ emitEvent: false });
      // }
    }
  }

  get InputOTP() {
    return this.passwordForm.get('InputOTP');
  }


  passwordValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName] as FormControl;
      const matchingControl = formGroup.controls[matchingControlName] as FormControl;

      if (matchingControl?.errors && !matchingControl?.errors['confirmedValidator']) {
        return;
      }

      if (control?.value !== matchingControl?.value) {
        matchingControl?.setErrors({ confirmedValidator: true });
      } else {
        matchingControl?.setErrors(null);
      }
    };
  }


  getSubmitText(): string {
    return this.isInitial ? 'SAVE' : 'VALIDATE';
  }

  onSelectOrg(org: OrgMap): void {
    this.selectedOrganization = org;
  }

  checkSelection(org: OrgMap): boolean {
    return (
      this.selectedOrganization &&
      this.selectedOrganization.OrgCode === org.OrgCode
    );
  }

  onNext(): void {
    if (!!this.selectedOrganization) {
      this.dialogRef.close(this.selectedOrganization);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onChangePassword(): void {
    if (this.isInitial) {
      this.setInputOTPValidation(false);
      this.formSubmitted = true;
    }
    const PAYLOADs = this.passwordForm.getRawValue();
    if (this.passwordForm.valid) {
      const PAYLOAD = this.passwordForm.getRawValue();
      PAYLOAD.DOB = !!PAYLOAD.DOB
        ? moment(PAYLOAD.DOB).format(GLOBAL_CONSTANTS.DOB_FORMAT)
        : null;
      (this.isInitial
        ? this.service.onGlobalChangePassword(PAYLOAD)
        : this.service.onGlobalChangePasswordValidate(PAYLOAD)
      )
        .pipe(takeUntil(this.destroy))
        .subscribe(
          (response: any) => {
            if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
              if (this.isInitial) {
                this.disabledField();
                this.isInitial = false;
                this.showOTPBox = true;
                this.resendOTPTimerFn();
                this.setInputOTPValidation(true);
                this.service.showToast("An OTP has been sent to you (Valid upto 4 Minutes)..", 'Success')

                // Focus the OTP input box after enabling it
                // setTimeout(() => {
                //   const firstInput =
                //     this.OTP.nativeElement.querySelector(
                //       'input'
                //     );
                //   firstInput?.focus();
                // }, 0);

                setTimeout(() => {
                  if (this.OTP && this.OTP.nativeElement) {
                    const firstInput = this.OTP.nativeElement.querySelector('input');
                    firstInput?.focus();
                  }
                }, 0);
              } else {
                this.service.showToast("Password changed successfully", 'Success');
                this.dialogRef.close();
                this.passwordForm?.reset();
                this.router.navigate(['authentication'], {
                  replaceUrl: true,
                });
              }
            } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
              this.service.showToast(response.Error.ErrorMessage, 'Error!');

            }
          },
          (err) =>
            this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE, 'Error!')
        );
    } else {
      if (!this.passwordForm.valid) {
        this.passwordForm.markAllAsTouched();
        this.passwordForm.markAsDirty();
        this.service.showToast(ADMIN_CONSTANT.FORM_INVALID, 'Error!');

      } else if (!this.passwordForm.dirty) {
        this.service.showToast(ADMIN_CONSTANT.FORM_UNTOUCHED, 'Warning!');

      }
    }
  }


  get f() { return this.passwordForm.controls; }


  get DOB() {
    return this.passwordForm.get('DOB');
  }
  get Email() {
    return this.passwordForm.get('Email');
  }
  get AdminPassword() {
    return this.passwordForm.get('AdminPassword');
  }
  get NewAdminPassword() {
    return this.passwordForm.get('NewAdminPassword');
  }
  
  get ReNewAdminPassword() {
    return this.passwordForm.get('ReNewAdminPassword');
  }


  disabledField(): void {
    this.DOB?.disable();
    this.Email?.disable();
    this.AdminPassword?.disable();
    this.NewAdminPassword?.disable();

    this.ReNewAdminPassword?.disable();

    this.passwordForm?.updateValueAndValidity();
  }


  getForgotPassResendOTP() {
    const PAYLOAD = this.passwordForm.getRawValue();
    PAYLOAD.DOB = !!PAYLOAD.DOB
      ? moment(PAYLOAD.DOB).format(GLOBAL_CONSTANTS.DOB_FORMAT)
      : null;
    this.service
      .onGlobalChangePassworResendOTP(PAYLOAD)
      .pipe(takeUntil(this.destroy))
      .subscribe(
        (response: any) => {
          if (response && response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
            this.resendOTPTimerFn();
            this.service.showToast("An OTP has been sent to you (Valid upto 4 Minutes)..", 'Success')
          } else {
            this.service.showToast(response.Error.ErrorMessage, 'Error!');
          }
        },
        (err: any) =>
          this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE, 'Error!')
      );
  }

  setInputOTPValidation(set: boolean): void {
    if (set) {
      this.InputOTP?.setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(6),
        Validators.pattern('^\\d{6}$'),
      ]);
    } else {
      this.InputOTP?.clearValidators();
    }
    this.InputOTP?.updateValueAndValidity();
  }

  resendOTPTimerFn(): void {
    this.resendOTP = false;
    this.resendOTPTimer = GLOBAL_CONSTANTS.RESEND_OTP_TIMER;
    timer(GLOBAL_CONSTANTS.TIMER_DURATION_ULTRA_HIGH)
      .pipe(takeWhile(() => !this.resendOTP))
      .subscribe(() => (this.resendOTP = true));
    interval(1000)
      .pipe(takeWhile(() => !this.resendOTP, true))
      .subscribe(() => {
        this.resendOTPTimer = this.resendOTP
          ? GLOBAL_CONSTANTS.RESEND_OTP_TIMER
          : this.resendOTPTimer > 0
            ? --this.resendOTPTimer
            : 0;
      });
  }

  onOtpChange(value: string) {
    // value.length == 6 ? this.InputOTP?.setValue(value) : null;
    this.InputOTP?.setValue(value);
    this.InputOTP?.updateValueAndValidity();
  }


  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid':
        form.get(field)!.invalid &&
        (form.get(field)!.dirty || form.get(field)!.touched),
      'is-valid':
        form.get(field)!.valid &&
        (form.get(field)!.dirty || form.get(field)!.touched),
    };
  }


}

